"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _analyticsActionKeys = _interopRequireDefault(require("./analyticsActionKeys"));

var _tracker = _interopRequireDefault(require("./tracker"));

var _analyticsUtils = require("./analyticsUtils");

/* nextjs doesn't use app-platform redux middleware so we need to support both shapes */
var retrieveState = function retrieveState(dispatchOrMiddleware, maybeGetState) {
  if (maybeGetState) {
    return {
      state: maybeGetState()
    };
  } else {
    var getState = dispatchOrMiddleware.getState;
    return {
      state: getState()
    };
  }
};

var sendTrackEvent = function sendTrackEvent(e, analyticsValues, callback, analyticsFn) {
  var defaultProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (state) {
    return {};
  };
  var extendState = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (state) {
    return state;
  };
  return function (dispatchOrMiddleware, maybeGetState) {
    var _retrieveState = retrieveState(dispatchOrMiddleware, maybeGetState),
        state = _retrieveState.state;

    var extendedState = extendState(state);
    (0, _analyticsUtils.fireEachEvent)(e, analyticsValues, callback, extendedState, analyticsFn, defaultProps(extendedState));
    return {
      type: 'SEND_TRACK_EVENT'
    };
  };
};

var sendEnhancedTrackEvent = function sendEnhancedTrackEvent(rules) {
  return function (dispatchOrMiddleware, maybeGetState) {
    var _retrieveState2 = retrieveState(dispatchOrMiddleware, maybeGetState),
        state = _retrieveState2.state;

    _tracker.default.enhancedTrack(rules, state);

    return {
      type: _analyticsActionKeys.default.SEND_ENHANCED_TRACK_EVENT,
      payload: rules
    };
  };
};

var sendEnhancedAnalyticsEvent = function sendEnhancedAnalyticsEvent(rules) {
  return function (dispatchOrMiddleware, maybeGetState) {
    var _retrieveState3 = retrieveState(dispatchOrMiddleware, maybeGetState),
        state = _retrieveState3.state;

    _tracker.default.enhancedAnalyticsEvent(rules, state);

    return {
      type: _analyticsActionKeys.default.SEND_ENHANCED_ANALYTICS_EVENT,
      payload: rules
    };
  };
};

var _default = {
  sendTrackEvent: sendTrackEvent,
  sendEnhancedTrackEvent: sendEnhancedTrackEvent,
  sendEnhancedAnalyticsEvent: sendEnhancedAnalyticsEvent
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/analyticsActions.js
// module id = 1831
// module chunks = 25